export const FETCH_RESERVATIONS_REQUEST = 'FETCH_RESERVATIONS_REQUEST'
export const FETCH_RESERVATIONS_SUCCESS = 'FETCH_RESERVATIONS_SUCCESS'
export const FETCH_RESERVATIONS_ERROR = 'FETCH_RESERVATIONS_ERROR'

export const FETCH_CART_REQUEST = 'FETCH_CART_REQUEST';
export const FETCH_CART_SUCCESS = 'FETCH_CART_SUCCESS';
export const FETCH_CART_ERROR = 'FETCH_CART_ERROR';
